// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"40":"13b0a18c","78":"679e6aa1","146":"154e09e5","423":"154e09e5","715":"584db4ad","797":"679e6aa1","842":"154e09e5","947":"679e6aa1"}[chunkId] + ".chunk.css";
};